import portfolioData from "../data/portfolio.json";

export class PortfolioModel {
  static getAllProjects() {
    return Object.values(portfolioData);
  }

  static getProjectBySlug(slug) {
    return portfolioData[slug] || null;
  }

  static getProjectById(id) {
    return (
      Object.values(portfolioData).find((project) => project.id === id) || null
    );
  }

  static getProjectsByCategory(category) {
    return Object.values(portfolioData).filter(
      (project) => project.category === category
    );
  }

  static searchProjects(query) {
    const searchTerm = query.toLowerCase();
    return Object.values(portfolioData).filter(
      (project) =>
        project.title.toLowerCase().includes(searchTerm) ||
        project.description.toLowerCase().includes(searchTerm) ||
        project.client.toLowerCase().includes(searchTerm)
    );
  }

  static getRelatedProjects(currentProjectId, limit = 3) {
    return Object.values(portfolioData)
      .filter((project) => project.id !== currentProjectId)
      .slice(0, limit);
  }

  static getFeaturedProjects(limit = 6) {
    return Object.values(portfolioData)
      .filter((project) => project.featured)
      .slice(0, limit);
  }

  static getProjectsByYear(year) {
    return Object.values(portfolioData).filter(
      (project) => project.year === year
    );
  }

  static getCategories() {
    const categories = new Set();
    Object.values(portfolioData).forEach((project) => {
      categories.add(project.category);
    });
    return Array.from(categories);
  }
}

export default PortfolioModel;
